/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
const perm = JSON.parse(sessionStorage.getItem("permissions") || "[]");
export const defaultNavigation: FuseNavigationItem[] = [
    {
        id      : 'applications',
        title   : 'Administration',
        subtitle: 'Gestion de la plateforme',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id      : 'apps.dashboard',
                title   : 'Tableau de bord',
                type    : 'basic',
                icon    : 'heroicons_outline:chart-pie',
                link    : '/dashboard',
            },
            {
                id   : 'apps.competitions',
                title: 'Compétitions',
                type : 'basic',
                icon : 'heroicons_outline:calendar-days',
                link : '/apps/competitions',
                disabled: !perm.includes('competition.read')
            },
            {
                id      : 'apps.questions',
                title   : 'Questions',
                type    : 'basic',
                icon    : 'heroicons_outline:question-mark-circle',
                link : '/apps/questions',
                disabled: !perm.includes('question.read')
            },
            {
                id   : 'apps.articles',
                title: 'Articles',
                type : 'basic',
                icon : 'heroicons_outline:newspaper',
                link : '/apps/articles',
                disabled: !perm.includes('article.read')
            },
            {
                id   : 'apps.media',
                title: 'Médiathèque',
                type : 'basic',
                icon : 'heroicons_outline:photo',
                link : '/apps/media',
                disabled: !perm.includes('media.read')
            },
            {
                id      : 'apps.knowledge-domains',
                title   : 'Domaines de connaissance',
                type    : 'basic',
                icon    : 'heroicons_outline:light-bulb',
                link : '/apps/knowledge-domains',
                disabled: !perm.includes('knowledge-domain.read')
            },
            {
                id      : 'apps.question-levels',
                title   : 'Niveaux de question',
                type    : 'basic',
                icon    : 'heroicons_outline:chart-bar',
                link : '/apps/question-levels',
                disabled: !perm.includes('question-level.read')
            },
            {
                id      : 'apps.player-levels',
                title   : 'Niveaux de joueur',
                type    : 'basic',
                icon    : 'heroicons_outline:trophy',
                link : '/apps/player-levels',
                disabled: !perm.includes('player-level.read')
            },
            {
                id      : 'apps.players',
                title   : 'Joueurs & Niveaux',
                type    : 'basic',
                icon    : 'heroicons_outline:user-group',
                link : '/apps/player-levels/players',
                disabled: !perm.includes('player.read')
            },
            {
                id      : 'apps.countries',
                title   : 'Pays',
                type    : 'basic',
                icon    : 'heroicons_outline:globe-alt',
                link : '/apps/countries',
                disabled: !perm.includes('country.read')
            },
            {
                id      : 'apps.partners',
                title   : 'Partenaires',
                type    : 'basic',
                icon    : 'heroicons_outline:building-office-2',
                link : '/apps/partners',
                disabled: !perm.includes('partner.read')
            },
            {
                id      : 'apps.partner-ads',
                title   : 'Publicités partenaires',
                type    : 'basic',
                icon    : 'heroicons_outline:megaphone',
                link    : '/apps/partner-ads',
                disabled: !perm.includes('partner-ad.read')
            },
            {
                id      : 'apps.payments',
                title   : 'Paiements',
                type    : 'basic',
                icon    : 'heroicons_outline:credit-card',
                link : '/apps/payments',
            },
            {
                id      : 'apps.users',
                title   : 'Utilisateurs',
                type    : 'basic',
                icon    : 'heroicons_outline:users',
                link : '/apps/users',
                disabled: !perm.includes('user.read')
            },
            {
                id      : 'apps.newsletter',
                title   : 'Newsletter',
                type    : 'basic',
                icon    : 'heroicons_outline:envelope',
                link : '/apps/newsletter',
                disabled: !perm.includes('newsletter.read')
            },
            {
                id      : 'apps.contacts',
                title   : 'Contacts',
                type    : 'basic',
                icon    : 'heroicons_outline:phone',
                link : '/apps/contacts',
                disabled: !perm.includes('contact.read')
            },
            
        ]
    },
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
